import { Link } from 'react-router-dom';

export default function PlanosFooter() {
  return (
    <>
      {/* FAQ */}
      <section className="py-24 bg-luxury-black relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent"></div>

        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="font-['Playfair_Display'] text-4xl text-white mb-4">
              Perguntas <span className="text-gold-400 italic">Frequentes</span>
            </h2>
          </div>

          <div className="space-y-4">
            {[
              { p: 'Posso mudar de plano depois?', r: 'Sim! Você pode fazer upgrade para um plano superior a qualquer momento. O valor já pago será descontado proporcionalmente.' },
              { p: 'Como funciona o plano gratuito?', r: 'O plano Semente do Futuro é 100% gratuito e não requer cartão de crédito. Você pode experimentar a ferramenta e decidir se quer evoluir para um plano pago.' },
              { p: 'Posso cancelar a qualquer momento?', r: 'Sim, você tem total liberdade para cancelar. Nos planos de pagamento único, você mantém acesso vitalício. Nas assinaturas, o acesso permanece até o fim do período pago.' },
              { p: 'Como funciona o plano Private?', r: 'O plano Private é personalizado e requer uma aplicação. Após análise, você receberá uma proposta customizada com sessões individuais e acompanhamento exclusivo.' },
              { p: 'Há garantia de reembolso?', r: 'Sim! Oferecemos garantia de 7 dias para todos os planos pagos. Se não ficar satisfeito, devolvemos 100% do valor.' }
            ].map((faq, index) => (
              <details key={index} className="group bg-white/[0.03] rounded-xl border border-gold-500/10 overflow-hidden hover:border-gold-500/20 transition-all">
                <summary className="px-6 py-5 cursor-pointer flex items-center justify-between font-['Montserrat'] font-semibold text-sm text-white/80 hover:text-gold-400 transition-colors tracking-wide">
                  <span>{faq.p}</span>
                  <i className="ri-arrow-down-s-line text-xl text-gold-400 group-open:rotate-180 transition-transform"></i>
                </summary>
                <div className="px-6 pb-5 font-['Montserrat'] text-sm text-white/50 leading-relaxed font-light">
                  {faq.r}
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-24 bg-luxury-black relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-gold-500/3 to-transparent"></div>

        <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
          <i className="ri-rocket-line text-5xl text-gold-400 mb-6 block"></i>
          <h2 className="font-['Playfair_Display'] text-4xl lg:text-5xl text-white mb-6">
            Pronto para Construir Seu <span className="text-gold-400 italic">Futuro?</span>
          </h2>
          <p className="font-['Montserrat'] text-base text-white/50 mb-10 font-light tracking-wide leading-relaxed">
            Comece gratuitamente hoje e descubra o poder de se conectar com a pessoa que você está se tornando.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/" className="px-10 py-4 bg-gradient-to-r from-gold-500 to-gold-700 text-white font-['Montserrat'] font-semibold rounded-lg hover:shadow-[0_0_30px_rgba(201,168,76,0.3)] transition-all whitespace-nowrap tracking-wider uppercase text-sm">
              Começar Gratuitamente
            </Link>
            <Link to="/sobre" className="px-10 py-4 border border-gold-500/30 text-gold-400 font-['Montserrat'] font-semibold rounded-lg hover:bg-gold-500/10 transition-all whitespace-nowrap tracking-wider uppercase text-sm">
              Saber Mais
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0d0b08] py-16 relative border-t border-gold-500/15">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/30 to-transparent"></div>

        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-12 mb-12">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <img
                  src="https://static.readdy.ai/image/9b313db6312c9605d9f9e3f145d3e29c/a68d70c6b66064870b0e9282c113321b.jpeg"
                  alt="Bia Holmes"
                  className="w-24 h-24 object-contain rounded-xl bg-white p-0.5 flex-shrink-0"
                />
                <h3 className="font-['Playfair_Display'] text-2xl font-semibold text-white">
                  Carta do Eu Futuro
                </h3>
              </div>
              <p className="font-['Montserrat'] text-xs text-white/55 leading-relaxed tracking-wide font-light">
                Uma experiência transformadora de autoconhecimento e planejamento emocional baseada em PNL.
              </p>
            </div>

            <div>
              <h4 className="font-['Montserrat'] font-semibold text-xs uppercase tracking-[0.2em] text-gold-400 mb-5">
                <a href="#" className="hover:text-gold-300 transition-colors cursor-pointer">Links Rápidos</a>
              </h4>
              <ul className="space-y-3">
                {[
                  { label: 'Início', href: '/' },
                  { label: 'Galeria de Cartas', href: '/galeria' },
                  { label: 'Comunidade', href: '/comunidade' },
                  { label: 'Blog', href: '/blog' },
                  { label: 'FAQ', href: '/faq' },
                  { label: 'Sobre', href: '/sobre' },
                  { label: 'Privacidade', href: '/privacidade' },
                  { label: 'Termos de Uso', href: '/termos' },
                ].map((link, i) => (
                  <li key={i}>
                    <a href={link.href} className="font-['Montserrat'] text-xs text-white/60 hover:text-gold-400 transition-colors cursor-pointer tracking-wide">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-['Montserrat'] font-semibold text-xs uppercase tracking-[0.2em] text-gold-400 mb-5">
                Conecte-se
              </h4>
              <div className="flex gap-3">
                <a href="https://www.instagram.com/bia.holmes" target="_blank" rel="noopener noreferrer nofollow" className="w-10 h-10 rounded-lg border border-gold-500/30 hover:border-gold-500 hover:bg-gradient-to-br hover:from-gold-500 hover:to-gold-700 flex items-center justify-center transition-all duration-300 cursor-pointer text-white/60 hover:text-white" aria-label="Instagram">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
                <a href="#" rel="nofollow" className="w-10 h-10 rounded-lg border border-gold-500/30 hover:border-gold-500 hover:bg-gradient-to-br hover:from-gold-500 hover:to-gold-700 flex items-center justify-center transition-all duration-300 cursor-pointer text-white/60 hover:text-white" aria-label="YouTube">
                  <i className="ri-youtube-fill text-lg"></i>
                </a>
              </div>
              <p className="font-['Montserrat'] text-xs text-white/60 mt-4 tracking-wide">
                <i className="ri-mail-line mr-2 text-gold-400"></i>
                contato@cartafuturo.org
              </p>
            </div>
          </div>

          <div className="border-t border-gold-500/15 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="font-['Montserrat'] text-xs text-white/45 tracking-wide">
                © 2025 Carta do Eu Futuro. Todos os direitos reservados.
              </p>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer nofollow" className="font-['Montserrat'] text-xs text-white/45 hover:text-gold-400 transition-colors cursor-pointer tracking-wide">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
